import React from "react";
import styled from "styled-components";
// Assets
import ContactImg1 from "../../assets/img/contact-1.png";
import ContactImg2 from "../../assets/img/contact-2.png";
import ContactImg3 from "../../assets/img/contact-3.png";

export default function Contact() {
  return (
    <Wrapper id="contact">
      <div className="lightBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font30 extraBold">Demo</h1>
            <p className="font13">
              Experience the future of legal practice. Share a few details about your firm, and we&apos;ll schedule a tailored demo with a product specialist—guided walkthrough of key workflows, answers to security and compliance questions, and a rollout plan for your team.
            </p>
          </HeaderInfo>
          <div className="row" style={{ paddingBottom: "30px" }}>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <Form>
                <label className="font13">Name:</label>
                <input type="text" id="fname" name="fname" className="font20 extraBold" placeholder="Your name" />
                <label className="font13">Work email:</label>
                <input type="email" id="email" name="email" className="font20 extraBold" placeholder="you@firm.com" />
                <label className="font13">Firm name:</label>
                <input type="text" id="subject" name="subject" className="font20 extraBold" placeholder="Your law firm" />
                <label className="font13">What would you like to improve?</label>
                <textarea rows="4" cols="50" id="message" name="message" className="font20 extraBold" placeholder="Tell us about your current tools and workflows…" />
              </Form>
              <SumbitWrapper className="flex">
                <ButtonInput type="submit" value="Request Demo" className="pointer animate radius8" style={{ maxWidth: "220px" }} />
              </SumbitWrapper>
            </div>
            <ImagesColumn className="col-xs-12 col-sm-12 col-md-6 col-lg-6 flex">
              <ImagesColumnHalf className="flexNullCenter flexColumn">
                <ContactImgBox>
                  <img src={ContactImg1} alt="office" className="radius6" />
                </ContactImgBox>
                <ContactImgBox>
                  <img src={ContactImg2} alt="office" className="radius6" />
                </ContactImgBox>
              </ImagesColumnHalf>
              <ImagesColumnHalf style={{ marginTop: "100px" }}>
                <img src={ContactImg3} alt="office" className="radius6" />
              </ImagesColumnHalf>
            </ImagesColumn>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  overflow-x: hidden;
`;
const HeaderInfo = styled.div`
  padding: 70px 0 30px 0;
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const Form = styled.form`
  padding: 70px 0 30px 0;
  input,
  textarea {
    width: 100%;
    background-color: transparent;
    border: 0px;
    outline: none;
    box-shadow: none;
    border-bottom: 1px solid #707070;
    height: 30px;
    margin-bottom: 30px;
  }
  textarea {
    min-height: 100px;
  }
  @media (max-width: 860px) {
    padding: 30px 0;
  }
`;
const ButtonInput = styled.input`
  border: 1px solid #D4AF37;
  background-color: #D4AF37;
  width: 100%;
  padding: 15px;
  outline: none;
  color: #fff;
  :hover {
    background-color: #0B093B;
    border: 1px solid #0B093B;
    color: #fff;
  }
  @media (max-width: 991px) {
    margin: 0 auto;
  }
`;
const ImagesColumn = styled.div`
  min-width: 0;
  img {
    max-width: 100%;
    height: auto;
    display: block;
  }
`;
const ImagesColumnHalf = styled.div`
  width: 50%;
  min-width: 0;
  img {
    max-width: 100%;
    height: auto;
    display: block;
  }
  @media (max-width: 860px) {
    width: 100%;
    margin-top: 20px !important;
  }
`;
const ContactImgBox = styled.div`
  max-width: 180px;
  min-width: 0;
  align-self: flex-end;
  margin: 10px 30px 10px 0;
  img {
    max-width: 100%;
    height: auto;
  }
`;
const SumbitWrapper = styled.div`
  @media (max-width: 991px) {
    width: 100%;
    margin-bottom: 50px;
  }
`;









